export default {"src":"https://fishbrain.com/_next/static/media/waxing_crescent.c37f184e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};